
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/create-hive-account",
      function () {
        return require("private-next-pages/dashboard/create-hive-account.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/create-hive-account"])
      });
    }
  